import React from 'react';
import MDEditor from '@uiw/react-md-editor';

// Document tags inserted via '#' have an in-app path, so they are shown as
// text instead of navigating; attachment links are absolute URLs.
const isDocumentTag = (href = '') => href.startsWith('/');

function NewTabLink({ href, children }) {
  if (isDocumentTag(href)) {
    return <span className="md-document-tag">{children}</span>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

// Module-level constant, so it is stable across renders
const COMPONENTS = { a: NewTabLink };

export default function MdDataPreview({ value }) {
  return (
    <div data-color-mode="light" className="github-md-preview-only">
      <MDEditor.Markdown source={value || ''} components={COMPONENTS} />
    </div>
  );
}
